import { isBot } from 'holocron/bot-agents';

import isPrerender from 'Helpers/SEO/is-prerender';

export default function isBotOrPrerender() {
  return isPrerender() || isBot(navigator?.userAgent || '');
}
